import type { AiStreamingOrchestratorPluginOptions } from '@atlassian/editor-plugin-ai-streaming-orchestrator';

type Props = {
	options: AiStreamingOrchestratorPluginOptions | undefined;
};

// eslint-disable-next-line jsdoc/require-jsdoc
export function aiStreamingOrchestratorPluginOptions({
	options,
}: Props): AiStreamingOrchestratorPluginOptions | undefined {
	return {
		streamFlowPacerEnabled: options?.streamFlowPacerEnabled,
		telemetryEventsEnabled: true,
	};
}
